import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-version",
  "use": "icon-version-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-version\">\r\n<path id=\"icon-version_路径_1994\" d=\"M10,19.7c5.3,0,9.7-4.3,9.7-9.7S15.3,0.3,10,0.3S0.3,4.7,0.3,10l0,0C0.3,15.3,4.7,19.7,10,19.7z M6.1,9\r\n\tl3.4-3.4c0,0,0,0,0.1-0.1c0.2-0.2,0.6-0.2,0.9,0c0,0,0,0,0.1,0.1L13.9,9c0.2,0.2,0.2,0.6,0,0.8c-0.2,0.2-0.6,0.2-0.8,0l-2.5-2.5v6.7\r\n\tc0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6c0,0,0,0,0,0V7.4L6.9,9.8c-0.2,0.2-0.6,0.2-0.8,0C5.9,9.6,5.9,9.2,6.1,9L6.1,9z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol